import type { Template } from "@/types";

export const SQ_04_H3_V1: Template[] = [
    {
        id: "sq-04-h3v1-01",
        name: "SQ 01 - H3V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h3_v1_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 178, y: 84, width: 361, height: 550, rotation: 0, imageRotation: 0 },
            { id: "2", x: 1004, y: 0, width: 353, height: 234, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1004, y: 242, width: 353, height: 234, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1004, y: 484, width: 353, height: 233, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h3v1-02",
        name: "SQ 02 - H3V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h3_v1_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 149, y: 39, width: 419, height: 639, rotation: 0, imageRotation: 0 },
            { id: "2", x: 923, y: 39, width: 306, height: 208, rotation: 0, imageRotation: 0 },
            { id: "3", x: 923, y: 255, width: 306, height: 208, rotation: 0, imageRotation: 0 },
            { id: "4", x: 923, y: 471, width: 306, height: 208, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h3v1-03",
        name: "SQ 03 - H3V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h3_v1_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 40, y: 39, width: 307, height: 209, rotation: 0, imageRotation: 0 },
            { id: "2", x: 40, y: 256, width: 307, height: 208, rotation: 0, imageRotation: 0 },
            { id: "3", x: 40, y: 472, width: 307, height: 209, rotation: 0, imageRotation: 0 },
            { id: "4", x: 977, y: 39, width: 421, height: 642, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h3v1-04",
        name: "SQ 04 - H3V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h3_v1_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 219, width: 406, height: 282, rotation: 0, imageRotation: 0 },
            { id: "2", x: 414, y: 219, width: 406, height: 282, rotation: 0, imageRotation: 0 },
            { id: "3", x: 828, y: 219, width: 195, height: 282, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1031, y: 219, width: 409, height: 282, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h3v1-05",
        name: "SQ 05 - H3V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h3_v1_05.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 112, width: 351, height: 244, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 363, width: 351, height: 244, rotation: 0, imageRotation: 0 },
            { id: "3", x: 359, y: 112, width: 736, height: 495, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1103, y: 112, width: 337, height: 495, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h3v1-06",
        name: "SQ 06 - H3V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h3_v1_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 43, y: 126, width: 331, height: 230, rotation: 0, imageRotation: 0 },
            { id: "2", x: 43, y: 364, width: 331, height: 229, rotation: 0, imageRotation: 0 },
            { id: "3", x: 382, y: 126, width: 688, height: 467, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1078, y: 126, width: 317, height: 467, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h3v1-07",
        name: "SQ 07 - H3V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h3_v1_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 43, y: 126, width: 331, height: 230, rotation: 0, imageRotation: 0 },
            { id: "2", x: 43, y: 364, width: 331, height: 229, rotation: 0, imageRotation: 0 },
            { id: "3", x: 382, y: 126, width: 315, height: 467, rotation: 0, imageRotation: 0 },
            { id: "4", x: 705, y: 126, width: 690, height: 467, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h3v1-08",
        name: "SQ 08 - H3V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h3_v1_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 109, y: 0, width: 496, height: 720, rotation: 0, imageRotation: 0 },
            { id: "2", x: 613, y: 0, width: 717, height: 465, rotation: 0, imageRotation: 0 },
            { id: "3", x: 613, y: 474, width: 354, height: 246, rotation: 0, imageRotation: 0 },
            { id: "4", x: 976, y: 474, width: 354, height: 246, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h3v1-09",
        name: "SQ 09 - H3V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h3_v1_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 43, y: 44, width: 628, height: 405, rotation: 0, imageRotation: 0 },
            { id: "2", x: 43, y: 457, width: 310, height: 215, rotation: 0, imageRotation: 0 },
            { id: "3", x: 360, y: 457, width: 311, height: 215, rotation: 0, imageRotation: 0 },
            { id: "4", x: 860, y: 44, width: 431, height: 628, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h3v1-10",
        name: "SQ 10 - H3V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h3_v1_10.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 70, y: 166, width: 577, height: 387, rotation: 0, imageRotation: 0 },
            { id: "2", x: 787, y: 85, width: 578, height: 274, rotation: 0, imageRotation: 0 },
            { id: "3", x: 788, y: 366, width: 382, height: 267, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1178, y: 366, width: 188, height: 267, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h3v1-11",
        name: "SQ 11 - H3V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h3_v1_11.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 137, y: 132, width: 444, height: 294, rotation: 0, imageRotation: 0 },
            { id: "2", x: 137, y: 434, width: 218, height: 153, rotation: 0, imageRotation: 0 },
            { id: "3", x: 363, y: 434, width: 218, height: 153, rotation: 0, imageRotation: 0 },
            { id: "4", x: 867, y: 61, width: 417, height: 597, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h3v1-12",
        name: "SQ 12 - H3V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h3_v1_12.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 355, y: 75, width: 238, height: 320, rotation: 0, imageRotation: 0 },
            { id: "2", x: 601, y: 75, width: 485, height: 320, rotation: 0, imageRotation: 0 },
            { id: "3", x: 355, y: 403, width: 361, height: 241, rotation: 0, imageRotation: 0 },
            { id: "4", x: 725, y: 403, width: 361, height: 241, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h3v1-13",
        name: "SQ 13 - H3V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h3_v1_13.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 89, y: 163, width: 541, height: 393, rotation: 0, imageRotation: 0 },
            { id: "2", x: 796, y: 163, width: 289, height: 193, rotation: 0, imageRotation: 0 },
            { id: "3", x: 796, y: 364, width: 289, height: 192, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1093, y: 163, width: 266, height: 393, rotation: 0, imageRotation: 0 }
        ],
    },

   

];

